//トップページ
export function homeFunc() {
  kvVisualChange();
  movieBackground();
  characterSwitch();
}

/**
 * キャラクターセクションの切り替え
 */
function characterSwitch() {
  const root = document.querySelector('[data-character-switch]');
  if (!root) return;

  const triggers = Array.prototype.slice.call(root.querySelectorAll('[data-character-trigger]'));
  const panels = Array.prototype.slice.call(root.querySelectorAll('[data-character-panel]'));
  if (triggers.length === 0 || panels.length === 0) return;

  let current = panels.findIndex((panel) => panel.classList.contains('is-active'));
  if (current < 0) current = 0;

  // 初期表示はフェードなしで表示済みにする
  panels[current].classList.add('is-shown');

  function setActive(index) {
    if (index === current) return;
    current = index;

    triggers.forEach((trigger, i) => {
      const active = i === index;
      trigger.classList.toggle('is-active', active);
      trigger.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    panels.forEach((panel, i) => {
      const active = i === index;
      panel.classList.toggle('is-active', active);
      panel.classList.remove('is-shown');
      panel.toggleAttribute('hidden', !active);
      panel.setAttribute('aria-hidden', active ? 'false' : 'true');

      if (!active) return;

      // display 切り替え後にトランジションを発火させる
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          panel.classList.add('is-shown');
        });
      });
    });
  }

  triggers.forEach((trigger, index) => {
    trigger.addEventListener('click', function () {
      setActive(index);
    });
  });
}

/**
 * MOVIEセクションの背景動画
 * フェードイン（opacity:0）中は自動再生がブロックされるため、
 * .is-visible 付与後に data-movie-bg-src を iframe へ流し込む
 */
function movieBackground() {
  const container = document.querySelector('.p-home-movie__content');
  const iframe = container && container.querySelector('.p-home-movie__content-movie');
  if (!container || !iframe) return;

  const bgSrc = iframe.getAttribute('data-movie-bg-src') || '';
  if (!bgSrc) return;

  let started = false;

  function startPlayback() {
    if (started || !container.classList.contains('is-visible')) return;
    started = true;
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    iframe.src = bgSrc;
  }

  if (container.classList.contains('is-visible')) {
    startPlayback();
    return;
  }

  const observer = new MutationObserver(function () {
    if (!container.classList.contains('is-visible')) return;
    observer.disconnect();
    startPlayback();
  });
  observer.observe(container, {
    attributes: true,
    attributeFilter: ['class'],
  });
}

/**
 * KV Visual Change（サムネイルでメインビジュアルを切り替え／自動切り替え）
 */
function kvVisualChange() {
  const switcher = document.querySelector('[data-kv-switch]');
  const visual = document.getElementById('js-kv-visual');
  // SP用メインビジュアルの <source>（picture で出し分けているため両方更新する）
  const visualSp = document.getElementById('js-kv-visual-sp');
  if (!switcher || !visual) return;

  const items = Array.prototype.slice.call(switcher.querySelectorAll('.p-home-kv__switch-item'));
  if (items.length === 0) return;

  let current = items.findIndex((item) => item.classList.contains('is-active'));
  if (current < 0) current = 0;

  function setActive(index) {
    if (index === current) return;
    const target = items[index];
    const url = target.getAttribute('data-kv-target');
    const urlSp = target.getAttribute('data-kv-target-sp') || url;

    items.forEach((item) => item.classList.remove('is-active'));
    target.classList.add('is-active');
    current = index;

    if (!url) return;

    // 現在の表示幅で実際に使われる画像をプリロードしてから切り替える
    const isSp = window.matchMedia('(max-width: 1024px)').matches;
    const preload = new Image();
    preload.onload = function () {
      visual.style.opacity = '0';
      window.setTimeout(function () {
        if (visualSp) visualSp.srcset = urlSp;
        visual.src = url;
        visual.style.opacity = '1';
      }, 250);
    };
    preload.src = isSp ? urlSp : url;
  }

  items.forEach((item, index) => {
    item.addEventListener('click', function () {
      setActive(index);
      // 切り替え時は画面トップへスムーススクロール
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });
}
